import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {SubCountyApi } from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';


@Component({
  selector: 'app-sub-counties',
  templateUrl: './sub-counties.component.html',
  styleUrls: ['./sub-counties.component.scss'],
  providers:[SubCountyApi,BaToastNotificationService]
})

@Injectable()
export class SubCountiesComponent implements OnInit {

  private subCountySource = new BehaviorSubject<object>({})
  sub_county = this.subCountySource.asObservable();

  private subCountiesSource = new BehaviorSubject<object>([])
  sub_counties = this.subCountiesSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected subCountyService:SubCountyApi,private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getSubCounties(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getSubCounties(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getSubCounties(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.subCountyService.find({
      order: "id DESC",
      include: ['county'],
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.subCountiesSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.subCountyService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.subCountyService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.subCountiesSource.next(results.data.sub_counties);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updateSubCountySource(data){
    this.subCountySource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.subCountySource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sub-counties/sub-counties.component.ts